import {Component} from 'react'
import Loader from 'react-loader-spinner'
import {formatDistanceToNow} from 'date-fns'
import Cookie from 'js-cookie'

import Header from '../Header'
import Sidebar from '../Sidebar'
import WatchVideoContainer from '../WatchVideoContainer'

import {NonHeaderContainer, VideoDetailsBgContainer} from './styledComponents'
import {
  LoaderContainer,
  RetryBtn,
  FailureContent,
  FailureHeading,
  NoVideoImg,
  NonVideoContainer,
} from '../Home/styledComponents'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const apiStatus = {
  initial: 'INITIAL',
  inProgress: 'IN_PROGRESS',
  success: 'SUCCESSFUL',
  failed: 'FAILURE',
}

class VideoItemDetailsRoute extends Component {
  state = {
    fetchStatus: apiStatus.initial,
    videoDetails: {},
    isLiked: false,
    isDisLiked: false,
  }

  componentDidMount() {
    this.setState({fetchStatus: apiStatus.inProgress})
    this.fetchVideoDetails()
  }

  onClickLike = () =>
    this.setState(prevState => ({
      isLiked: !prevState.isLiked,
      isDisLiked: false,
    }))

  onClickDisLike = () =>
    this.setState(prevState => ({
      isDisLiked: !prevState.isDisLiked,
      isLiked: false,
    }))

  fetchVideoDetails = async () => {
    const token = Cookie.get('jwt_token')
    const options = {
      headers: {Authorization: `Bearer ${token}`},
    }
    const {match} = this.props
    const {params} = match
    const {id} = params
    const response = await fetch(`https://apis.ccbp.in/videos/${id}`, options)
    if (response.ok) {
      const data = await response.json()
      const updatedObj = {
        id: data.video_details.id,
        title: data.video_details.title,
        videoUrl: data.video_details.video_url,
        thumbnailUrl: data.video_details.thumbnail_url,
        channel: {
          name: data.video_details.channel.name,
          profileImgUrl: data.video_details.channel.profile_image_url,
          subscriberCount: data.video_details.subscriber_count,
        },
        viewCount: data.video_details.view_count,
        publishedDuration: formatDistanceToNow(
          new Date(data.video_details.published_at),
        ),
        description: data.video_details.description,
      }
      this.setState({fetchStatus: apiStatus.success, videoDetails: updatedObj})
    } else {
      this.setState({fetchStatus: apiStatus.failed})
    }
  }

  renderFailedView = darkMode => {
    const imgUrl = darkMode
      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'
    return (
      <NonVideoContainer darkMode={darkMode}>
        <NoVideoImg src={imgUrl} alt="failure view" />
        <FailureHeading darkMode={darkMode}>
          Oops! Something Went Wrong
        </FailureHeading>
        <FailureContent darkMode={darkMode}>
          We are having some trouble to complete your request. Please try again.
        </FailureContent>
        <RetryBtn type="button" onClick={this.fetchVideoDetails}>
          Retry
        </RetryBtn>
      </NonVideoContainer>
    )
  }

  renderLoadingView = darkMode => (
    <LoaderContainer data-testid="loader">
      <Loader
        type="ThreeDots"
        color={darkMode ? '#3b82f6' : '#000000'}
        height="50"
        width="50"
      />
    </LoaderContainer>
  )

  renderRespectiveContainer = darkMode => {
    const {fetchStatus, videoDetails, isLiked, isDisLiked} = this.state
    switch (fetchStatus) {
      case apiStatus.failed:
        return this.renderFailedView(darkMode)
      case apiStatus.inProgress:
        return this.renderLoadingView(darkMode)
      case apiStatus.success:
        return (
          <WatchVideoContainer
            isLiked={isLiked}
            isDisLiked={isDisLiked}
            videoDetails={videoDetails}
            onClickLike={this.onClickLike}
            onClickDisLike={this.onClickDisLike}
          />
        )
      default:
        return null
    }
  }

  render() {
    return (
      <NxtWatchContext.Consumer>
        {value => {
          const {darkMode} = value
          return (
            <VideoDetailsBgContainer>
              <Header />
              <NonHeaderContainer
                data-testid="videoItemDetails"
                darkMode={darkMode}
              >
                <Sidebar />
                {this.renderRespectiveContainer(darkMode)}
              </NonHeaderContainer>
            </VideoDetailsBgContainer>
          )
        }}
      </NxtWatchContext.Consumer>
    )
  }
}
export default VideoItemDetailsRoute
